import { render, staticRenderFns } from "./SlideMobFull.vue?vue&type=template&id=21438311&scoped=true"
import script from "./SlideMobFull.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideMobFull.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SlideMobFull.vue?vue&type=style&index=0&id=21438311&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21438311",
  null
  
)

export default component.exports